const showFeedback = (content) => {
  const event = new CustomEvent('showFeedback', content)
  return window.dispatchEvent(event)
}

export default showFeedback
